export default "__VITE_ASSET__BaJcYRud__"